import React, { useRef } from "react";
import LottieAnimation from "../animations";

const MainLoader = () => {
    return (
        <div className="h-screen w-screen fixed top-2/4 left-2/4 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center bg-black bg-opacity-90 z-20">
            <div className="z-30 w-80">
            <LottieAnimation
                                lottieUrl="/animation/Loader.lottie"
                                height='400px'
                                width="400px"
                            />

            </div>
        </div>
    );
};

export default MainLoader;


